module.exports = __webpack_public_path__ + "img/plus-icon.6858da2f.svg";